export default [
  { field: 'relevante', label: 'Relevante', type: 'custom' },
  { field: 'lido', label: 'Lida', type: 'custom' },
  { field: 'remetente', label: 'Remetente', type: 'custom' },
  {
    field: 'assunto', label: 'Assunto', editable: true, evento: null, type: 'custom',
  },
  { field: 'enviadoEm', label: 'Data de envio', type: 'custom' },
  {
    field: 'dataPrimeiraLeitura', label: 'Data de Leitura', tdClass: 'text-center', type: 'custom',
  },
  {
    label: 'Consultado em', field: 'consultadoEm', type: 'custom',
  },
]
